/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import {InputAdornment} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/esm/Clear';

export default function UploadButton (props) {
	const [value, setValue] = useState(props.file);

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				gridArea: location
			}}
		>
			{value ? (
				<TextField
					sx={{
						// maxWidth: WIDTH[width],
						flex: '1',
					}}
					variant="outlined"
					margin="normal"
					size="small"
					disabled
					label={props.label}
					value={value}
					InputProps={{
						inputProps: {
							sx: {
								height: '22px'
							}
						},
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									size="small"
									onClick={async () => {
										try {
											setValue(undefined);
											props.onChange({
												name: undefined,
												content: undefined
											});
										} catch (error) {
											console.error(error);
										}
									}}
								>
									<CloseIcon />
								</IconButton>
							</InputAdornment>
						)
					}}
				/>
			) : (
				<TextField
					style={{
						// maxWidth: WIDTH[width],
						flex: '1',
					}}
					variant="outlined"
					size="small"
					margin="normal"
					inputProps={{
						accept: '*',
						type: 'file',
						sx: {
							height: '22px'
						}
					}}
					InputLabelProps={{
						shrink: true
					}}
					label={props.label}
					onChange={(event) => {
						// @ts-ignore
						// eslint-disable-next-line no-unused-vars
						const { files } = event.target;
						if (files && files.length) {
							const reader = new FileReader();
							// eslint-disable-next-line no-unused-vars
							reader.onloadend = async (fe) => {
								try {
									setValue(files[0].name);
									props.onChange({
										name: files[0].name,
										content: fe.target.result
									});
								} catch (error) {
									console.error(error);
								}
							};
							reader.readAsText(files[0]);
							// setLocal(files[0].name);
						}
					}}
				/>
			)}
		</div>
	);
}

